import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { CanvasJSChart } from "canvasjs-react-charts";
import { getChartOptions, buildChartData } from "../../Charts/chartDataService";

import { exampleData } from "./ChartContent/content.js";
import { withCustomReport } from "../../../shared/containers/containerCustomReport.js";
import { states } from "../../../reducers/queriesStates.js";

class ReportChartExample extends Component {
  render() {
    const { customReport } = this.props;

    const options = getChartOptions(buildChartData(exampleData, customReport, "unitId"), 300);

    const { updateCustomReportAxisDataState } = this.props;

    if (updateCustomReportAxisDataState === states.REQUEST) {
      return null;
    }

    return (
      <div style={{ paddingTop: "20px" }}>
        <CanvasJSChart options={options} />
      </div>
    );
  }
}

export default withCustomReport(React.memo(ReportChartExample));
